import { isEmpty } from 'lodash';

import { newFlowId } from '../../diagram/flows';
import { safeParseFloat } from '../number';

export type RangeValues = (string | number)[][];

export const isRangeValuesValid = (values: RangeValues) => {
  // Empty selection is considered invalid
  if (isEmpty(values)) {
    return false;
  }
  // Otherwise call the selection valid only if all rows are valid individually
  return values.every((row) => {
    const [source, target, amount, amountComparison] = row;
    // If the row has less than 3 or more than 4 columns, it is considered invalid
    if (row.length < 3 || row.length > 4) {
      return false;
    }
    // If both source and target labels are empty, the row is considered invalid
    if (source === '' && target === '') {
      return false;
    }
    // If the amount is not included in the range, the row is automatically considered invalid
    if (amount === undefined) {
      return false;
    }
    // The amount must always be a number or an empty string
    if (typeof amount !== 'number' && amount !== '') {
      return false;
    }
    // If the comparison amount is included in the range, it must be a number or an empty string
    if (
      amountComparison !== undefined &&
      typeof amountComparison !== 'number' &&
      amountComparison !== ''
    ) {
      return false;
    }
    // Otherwise the row is considered valid
    return true;
  });
};

export const selectionToFlows = (values: RangeValues) => {
  return values.map(
    (row, dataGridRowIndex): SankeyFormFlow => ({
      id: newFlowId(dataGridRowIndex),
      source: `${row[0]}`,
      target: `${row[1]}`,
      amount: safeParseFloat(row[2]),
      amountComparison: safeParseFloat(row[3]),
      dataGridRowIndex,
    })
  );
};
